export function exhaustiveFail(dummy: never, message: string = 'exhaustive check fails on value:'): never {
    throw new Error(message + dummy);
}